/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import CommonAlertCard from "../../../../components/_utils/CommonAlertCard/index.jsx";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import Loader from "../../../../components/Loader/Index";
import useServiceChecker from "../../../../components/ServiceChecker";
import BulkTransactionStepCategory from "../../../../components/Transactions/BulkTransaction/BulkTrasnactionCreate/BulkTransactionStepCategory/index.jsx";
import BulkTransactionStepUpload from "../../../../components/Transactions/BulkTransaction/BulkTrasnactionCreate/BulkTransactionStepUpload/index.jsx";
import {
  getAllCategories,
  uploadFile,
} from "../../../../redux/features/sharedResources/sharedResources";
import { bulkTransactionUpload } from "../../../../redux/features/transactions/beneficiaryTransactions";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../utils/bankingHours";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider";

function BulkTrasanctionCreate() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const previousCategoryStatusRef = useRef(null);
  const [ensureAll] = useServiceChecker();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [direction, setDirection] = useState(null);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [disabledLoading, setDisabledLoading] = useState(false);
  const [categoriesLoaded, setCategoriesLoaded] = useState(false);
  const [showBankingHoursPopup, setShowBankingHoursPopup] = useState(false);
  const isOutsideBankingHoursNow = isOutsideBankingHours();
  const shouldShowBankingHoursAlert =
    isOutsideBankingHoursNow &&
    activeStep === GlobalConfiguration.lengthCheckZero;

  const steps = ["Transaction category", "Upload transaction file"];

  const categoriesData = useSelector(
    (state) => state.sharedResources?.categoriesData,
  );

  const categories = categoriesData?.categories;

  const bulkUploadCategories = Array.isArray(categories)
    ? categories.filter((c) => c?.name?.trim() === "Bulk Upload")
    : [];

  const bulkUploadCategoryDetails =
    bulkUploadCategories.find((c) => c?.active === "Y") ??
    bulkUploadCategories[0];

  const isBulkUploadCategoryInactive =
    bulkUploadCategoryDetails?.active === "N";

  const isBulkUploadCategoryActive = bulkUploadCategoryDetails?.active === "Y";

  const selectedCategory = isBulkUploadCategoryActive
    ? bulkUploadCategoryDetails
    : null;

  const isBulkUploadCategoryMissing =
    Array.isArray(categories) && !bulkUploadCategoryDetails;

  const isFileSelected = files?.length !== GlobalConfiguration.lengthCheckZero;

  const canCreateCategory = ensureAll(["CTransactionCategory"]).status;

  const baseStepConfig = {
    previousEnableBgColor: "var(--primary-nav-act)",
    previousDisableBgColor: "var(--text-disabled)",
    previousEnableTextColor: "var(--text-primary)",
    previousHoverOption: "white",
    nextDisableBgColor: "var(--text-disabled)",
    nextDisableTextColor: "var(--text-primary)",
    nextHoverOption: "black",
  };

  const dataArrayBulk = [
    {
      ...baseStepConfig,
      previousText: "Cancel",
      nextText: "Next",
      nextEnableBgColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      nextIsEnabled: categoriesLoaded && !!selectedCategory,
      nextIsLoading: false,
      stepperText: steps[0],
    },
    {
      ...baseStepConfig,
      previousText: "Previous",
      nextText: "Upload",
      nextEnableBgColor: "var(--positive-act)",
      nextEnableTextColor: "var(--text-primary)",
      nextIsEnabled: isFileSelected,
      nextIsLoading: disabledLoading,
      stepperText: steps[1],
      extraInfoShow: false,
    },
  ];

  const renderCreateTxn = () => {
    switch (activeStep) {
      case 0:
        return (
          <BulkTransactionStepCategory
            bulkUploadCategoryDetails={bulkUploadCategoryDetails}
            handleCreateCategory={handleCreateCategory}
            handleUnassignNavigate={handleUnassignNavigate}
            bulkStatus={bulkStatus}
            canCreateCategory={canCreateCategory}
            isLoading={!categoriesLoaded}
          />
        );

      case 1:
        return (
          <BulkTransactionStepUpload
            files={files}
            setFiles={setFiles}
          />
        );

      default:
        return null;
    }
  };

  const handleUnassignNavigate = () => {
    const bulkUploadCategoryDetails = categories?.find(
      (category) => category.name === "Bulk Upload",
    );

    if (bulkUploadCategoryDetails?.id) {
      navigate(
        `/settings/category_dashboard/view_details/${bulkUploadCategoryDetails.id}`,
        { replace: false },
      );
    }
  };

  const bulkStatus = !categoriesLoaded
    ? null
    : isBulkUploadCategoryActive
      ? "active"
      : isBulkUploadCategoryInactive
        ? "inactive"
        : isBulkUploadCategoryMissing
          ? "missing"
          : null;

  const handleCreateCategory = () => {
    const serviceCheck = ensureAll(["CTransactionCategory"]);

    if (serviceCheck.status) {
      navigate("/settings/category_dashboard/add_category");
    } else {
      navigate("/feature_not_assigned", {
        state: serviceCheck.unavailableService,
      });
    }
  };

  const handleUpdate = async () => {
    if (disabledLoading) return;
    setDisabledLoading(true);
    setLoading(true);

    try {
      const fileResponse = await dispatch(uploadFile({ file: files }));

      if (fileResponse?.error) {
        CommonToast({
          text: "File upload failed",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        return;
      }

      const fileData = fileResponse?.payload;
      let bulkPayload = {
        uploaded_file_data: {
          id: fileData?.id,
          storage: "cache",
          metadata: {
            filename: fileData?.metadata?.filename,
            size: fileData?.metadata?.size,
            mime_type: fileData?.metadata?.mime_type,
          },
        },
      };

      let response;
      bulkPayload = {
        ...bulkPayload,
        category_id: selectedCategory?.id,
        category_name: selectedCategory?.name,
      };

      response = await dispatch(bulkTransactionUpload({ bulkPayload }));

      const data = response?.payload;

      if (data?.status === true) {
        navigate(
          "/beneficiary_transaction_dashboard/create_bulk_transaction/success",
          {
            state: { files, requestReferenceId: data?.request_reference_id },
          },
        );
      } else {
        setFiles([]);
        navigate(
          "/beneficiary_transaction_dashboard/create_bulk_transaction/error",
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setDisabledLoading(false);
    }
  };

  // const handleDownloadSample = async () => {
  //   try {
  //     CommonToast({
  //       text: "Downloading sample file.",
  //       icon: ICONS?.LOADER_GIF,
  //       variant: "var(--processing)",
  //       btnProps: {
  //         isDisabled: false,
  //         enabledTextColor: "var(--text-primary)",
  //         enabledBgColor: "var(--primary-bg)",
  //       },
  //     });
  //     await dispatch(
  //       bulkTransactionDownloadSampleFile({
  //         category_id: selectedCategory?.id,
  //       }),
  //     );
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  useEffect(() => {
    setFiles([]);
    setActiveStep(0);
  }, []);

  useEffect(() => {
    const refreshCategories = async () => {
      try {
        const response = await dispatch(getAllCategories());

        const fetchedCategories =
          response?.payload?.categoriesData?.categories ??
          response?.payload?.categories ??
          [];

        if (Array.isArray(fetchedCategories) && fetchedCategories.length) {
          const sameName = fetchedCategories.filter(
            (category) => category.name?.trim() === "Bulk Upload",
          );
          const bulkCategory =
            sameName.find((category) => category.active === "Y") ?? sameName[0];
          previousCategoryStatusRef.current = bulkCategory?.active ?? null;
        }
      } catch (error) {
        console.error(error);
      } finally {
        setCategoriesLoaded(true);
      }
    };

    refreshCategories();
  }, [dispatch]);

  useEffect(() => {
    if (direction) {
      const timer = setTimeout(() => {
        setRemoveClassName(true);
      }, 400);

      return () => clearTimeout(timer);
    }
  }, [activeStep]);

  useEffect(() => {
    let dragCounter = GlobalConfiguration?.lengthCheckZero;

    const handleDragEnter = (e) => {
      e.preventDefault();
      dragCounter++;
    };

    const handleDragLeave = (e) => {
      e.preventDefault();
      dragCounter--;
      if (dragCounter === GlobalConfiguration?.lengthCheckZero) {
      }
    };

    const handleDragOver = (e) => {
      e.preventDefault();
    };

    const handleDrop = (e) => {
      e.preventDefault();
      dragCounter = GlobalConfiguration?.lengthCheckZero;
    };

    window.addEventListener("dragenter", handleDragEnter);
    window.addEventListener("dragleave", handleDragLeave);
    window.addEventListener("dragover", handleDragOver);
    window.addEventListener("drop", handleDrop);

    return () => {
      window.removeEventListener("dragenter", handleDragEnter);
      window.removeEventListener("dragleave", handleDragLeave);
      window.removeEventListener("dragover", handleDragOver);
      window.removeEventListener("drop", handleDrop);
    };
  }, []);

  const animationClassS =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  useEffect(() => {
    if (direction) {
      const timer = setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration.intervalSmaller);
      return () => clearTimeout(timer);
    }
  }, [activeStep]);

  return (
    <>
      {showBankingHoursPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Why transaction cannot be processed?"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${getOutsideBankingHoursLabel()} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBankingHoursPopup(false)}
          />
        </div>
      )}
      <div className="flex flex-col h-screen overflow-hidden">
        <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height Qlg:bg-primary-bg bg-primary-nav flex-shrink-0"></div>

        {loading && (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-fixed-ui bg-PopUp-BackDrop opacity-dark-opacity">
            <div>
              <Loader type={"bulk_upload"} />
              <p className="font-semibold text-font-lg text-text-primary">
                Uploading file
              </p>
            </div>
          </div>
        )}

        <div className="h-loader-lg Qsmd:hidden block flex-shrink-0"></div>
        <div className="relative flex flex-col flex-1 overflow-hidden w-width-full">
          <div className="fixed top-top-base left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
            <TopNavComponent
              topNavHeader="Create bulk transaction"
              topNavSubText={steps[activeStep] || ""}
              isFormattingNotRequired
            />
          </div>
          <div className="fixed Qsmd:relative left-left-base z-z-index-loader flex justify-center items-center flex-col lg:flex-col-reverse w-width-full lg:py-padding-base bottom-bottom-base top-auto lg:top-top-base lg:bottom-auto Qsmd:bg-transparent shrink-0 Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-moble-height">
            <PrimaryStepper
              activeStep={activeStep}
              handleForwardAction={() => {
                if (activeStep === GlobalConfiguration.lengthCheckZero) {
                  if (!categoriesLoaded || !selectedCategory) return;
                  setDirection("next");
                  setRemoveClassName(false);
                  setActiveStep(1);
                } else {
                  if (files?.length === GlobalConfiguration?.lengthCheckZero)
                    return;
                  handleUpdate();
                }
              }}
              handleBackwardAction={() => {
                setDirection("prev");
                setRemoveClassName(false);
                if (activeStep === GlobalConfiguration?.lengthCheckZero) {
                  navigate(-1);
                } else {
                  setActiveStep(0);
                }
              }}
              dataArray={dataArrayBulk}
            />
          </div>

          <div
            className={`h-full w-width-full overflow-y-auto flex-1 mx-auto Qlg:px-padding-base px-padding-md ${activeStep === GlobalConfiguration?.lengthCheckZero ? " pt-[calc(var(--padding-md)+var(--borderthickness))] pb-padding-md" : "pt-padding-md"} ${
              activeStep === GlobalConfiguration.lengthCheckZero &&
              direction === "next"
                ? ""
                : removeClassName === true
                  ? ""
                  : animationClassS
            }`}
          >
            {shouldShowBankingHoursAlert && (
              <div className="max-w-tab-width-normal Qlg:mx-auto Qlg:px-padding-base w-width-full mb-margin-md">
                <CommonAlertCard
                  title="Functioning outside banking hours"
                  texts="Transactions will be processed automatically during the next bank working day. Learn more"
                  highlightedText="Learn more"
                  onHighlightedTextClick={() => setShowBankingHoursPopup(true)}
                />
              </div>
            )}

            {renderCreateTxn()}
          </div>
          <div className="h-stepper-moble-height flex Qsmd:hidden" />
        </div>
      </div>
    </>
  );
}

export default BulkTrasanctionCreate;
